import { Task } from '../task/task.model';

export class StipRequestTask extends Task {
    status: string;
    dealInfo: string;
}
